import { ProtectedRoute } from '@dealstack/frontend/shared/pages/ProtectedRoute/ProtectedRoute';
import { AUTH_ROUTES, Auth } from '@dealstack/frontend/admin/pages/Auth/Auth';
import { EidEasyFtnCallback } from '@dealstack/frontend/shared/components/EidEasySigningModal/EidEasyFtnCallback';
import { EidEasyOtpCallback } from '@dealstack/frontend/shared/components/EidEasySigningModal/EidEasyOtpCallback';
import { Files as ManageFilesRoutes } from '@dealstack/frontend/admin/pages/Manage/Files/Files';
import { ManageMipRoutes } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageMipRoutes';
import { ManageInvestors } from '@dealstack/frontend/admin/pages/Manage/User/ManageUser';
import { Navigate, Route } from 'react-router-dom';
import { useAppDispatch } from '@dealstack/frontend/admin/hooks/redux';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import { Dashboard } from '@dealstack/frontend/admin/pages/Dashboard/Dashboard';
import { ManagePreFillableForms } from '@dealstack/frontend/admin/pages/Manage/ManagePreFillableForms/ManagePreFillableForms';
import { ManageGeneratableDocuments } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/ManageGeneratableDocuments';
import { Page404 } from '@dealstack/frontend/shared/pages/Page404/Page404';
import { GenericError as GenericErrorPage } from '@dealstack/frontend/shared/pages/GenericError/GenericError';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { setApplicationType } from '@dealstack/frontend/shared/mechanism/redux/reducers/global/global';

interface Props {
	className?: string;
}

export enum GODMODE_ROOT_ROUTES {
	DASHBOARD = '/dashboard',
	IMPORT = '/import',
	MANAGE_USER = '/manage/user',
	MANAGE_MIP = '/manage/mip',
	MANAGE_FILES = '/manage/files',
	MANAGE_PRE_FILLABLE_FORMS = '/manage/pre-fillable-forms',
	MANAGE_GENERATABLE_DOCUMENTS = '/manage/manage-generatable-documents',
	EID_EASY_SIGNING_FTN_CALLBACK = '/eid-easy/ftn-callback',
	EID_EASY_SIGNING_OTP_CALLBACK = '/eid-easy/otp-callback',
	AUTH = '/auth',
	PAGE_NOT_FOUND = '/404',
	GENERIC_ERROR = '/error',
}

export const DEFAULT_PROTECTED_ROUTE = GODMODE_ROOT_ROUTES.DASHBOARD;
export const DEFAULT_GUEST_ROUTE = `${GODMODE_ROOT_ROUTES.AUTH}${AUTH_ROUTES.LOGIN}`;

export const Routing = ({ className }: Props) => {
	const dispatch = useAppDispatch();
	const applicationType = ApplicationType.GODMODE;
	dispatch(setApplicationType(applicationType));
	return (
		<div className={className}>
			<SentryRoutes>
				<Route
					path={`${GODMODE_ROOT_ROUTES.AUTH}/*`}
					element={<Auth applicationType={applicationType} />}
				/>
				<Route
					path={GODMODE_ROOT_ROUTES.DASHBOARD}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<Dashboard />
						</ProtectedRoute>
					}
				/>

				<Route
					path={`${GODMODE_ROOT_ROUTES.MANAGE_USER}/*`}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<ManageInvestors />
						</ProtectedRoute>
					}
				/>
				<Route
					path={`${GODMODE_ROOT_ROUTES.MANAGE_MIP}/*`}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<ManageMipRoutes />
						</ProtectedRoute>
					}
				/>
				<Route
					path={`${GODMODE_ROOT_ROUTES.MANAGE_FILES}/*`}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<ManageFilesRoutes />
						</ProtectedRoute>
					}
				/>
				<Route
					path={`${GODMODE_ROOT_ROUTES.MANAGE_PRE_FILLABLE_FORMS}/*`}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<ManagePreFillableForms />
						</ProtectedRoute>
					}
				/>
				<Route
					path={`${GODMODE_ROOT_ROUTES.MANAGE_GENERATABLE_DOCUMENTS}/*`}
					element={
						<ProtectedRoute
							defaultGuestRoute={DEFAULT_GUEST_ROUTE}
							dispatch={dispatch}
							applicationType={applicationType}
							defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}
						>
							<ManageGeneratableDocuments />
						</ProtectedRoute>
					}
				/>
				<Route
					path={GODMODE_ROOT_ROUTES.EID_EASY_SIGNING_FTN_CALLBACK}
					element={<EidEasyFtnCallback />}
				/>
				<Route
					path={GODMODE_ROOT_ROUTES.EID_EASY_SIGNING_OTP_CALLBACK}
					element={<EidEasyOtpCallback />}
				/>
				<Route path={GODMODE_ROOT_ROUTES.PAGE_NOT_FOUND} element={<Page404 />} />
				<Route path={GODMODE_ROOT_ROUTES.GENERIC_ERROR} element={<GenericErrorPage />} />
				<Route path="*" element={<Navigate to={GODMODE_ROOT_ROUTES.DASHBOARD} />} />
			</SentryRoutes>
		</div>
	);
};
